import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certapplyActions } from '../../../../../store/actions'
import Input from '../../../../../module/input'
import moment from 'moment'
import { commons } from '../../../../../hook/common'
import Calendar from '../../../../../module/component-box/Calendar'
import { contractConstants } from '../../../../../store/constants'
import * as common from '../../../../../assets/js/common.js'
/*import Calendar from '../../../../../module/calendar'*/

/**
 * 수출근거서류 등록/수정 팝업
 * @param props
 * @constructor
 */
const PopFiles = (props) => {
  const nodeBaseInfo = {
    fileCd: {
      title: '근거서류코드',
      length: 10,
      required: true,
    },
    fileNo: {
      title: '근거서류번호',
      type: 'text',
      length: 11,
      required: true,
      message: '근거서류번호를 입력해주세요.',
    },
    itemnm: {
      title: '품명',
      type: 'text',
      length: 35,
      required: true,
      readOnly: true,
      itemnm: false,
      className: 'form-keyword col',
      message: '품명을 선택해주세요.',
      placeholder: "'구매 물품 목록'에서 입력한 제품을 선택합니다.",
    },
    /*  itemdeftxt:{
      title:'규격',
      type: 'text',
      length: 10,
      readOnly: true,
      className:'form-keyword col1',
      placeholder:"'구매 물품 목록'에서 입력한 제품을 선택합니다."
    }, */
    hsCd: {
      title: 'HS부호',
      type: 'text',
      length: 10,
      required: true,
      message: 'HS부호를 입력해주세요.',
    },
    totamtcur: {
      title: '총금액통화코드',
      type: 'select',
      length: 3,
      readOnly: true,
    },
    amt: {
      title: '금액',
      type: 'number',
      required: true,
      message: '총금액을 입력해주세요.',
    },
    stngYmd: {
      title: '선적기일',
    },
    issueType: {
      title: '기관코드',
      type: 'text',
      readOnly: true,
    },
    issueCd: {
      title: '기관종류',
      type: 'text',
      readOnly: true,
    },
  }

  const fileType = [
    { title: '수출신고필증', value: '811' },
    { title: 'Documentary credit(수출신용장)', value: '465' },
    { title: '외화표시 물품공급계약서', value: '2AN' },
  ]

  const inputRef = React.useRef(new Array(Object.keys(nodeBaseInfo).length))
  const [state, setState] = useState({})
  const [nodeInfo, setNodeInfo] = useState(nodeBaseInfo)
  const [reset, setReset] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editIdx, setEditIdx] = useState(-1)
  const [itemList, setItemList] = useState(props.stepData)
  const [itemInput, setItemInput] = useState({ fileCd: '' })
  const [selectItems, setSelectItems] = useState([])

  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem(props.docid)).step3

    setItemList(list)
    commons.preventKeyDown()
  }, [])

  /**
   * 데이터 저장 후 입력폼 갱신
   */
  useEffect(() => {
    if (props.isCalled === true) {
      setItemList(props?.stepData)
      newInput()
      setReset(true)
    }
    props.setCalled(false)
  }, [props?.isCalled])

  /**
   * input 갱신을 위한 hook
   */
  useEffect(() => {
    if (reset === true) setReset(false)
  }, [reset])

  /**
   * 물품목록 선택팝업 콜백
   */
  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem(props.docid)).step2
    let item = list?.filter((item) => {
      return item.crtItemSeq === props.selectItemSeq
    })[0]

    item &&
      setItemInput({
        ...itemInput,
        hsCd: item?.hsCd,
        itemnm: item?.itemnm,
        itemdeftxt: item?.itemdeftxt,
      })
  }, [props.selectItemSeq])

  /**
   * 입력학목 유효성 체크 및 저장 api 호출
   */
  const saveItem = () => {
    setState({ ...state, submitted: !state.submitted, errCrtYmd: '' })

    let node = nodeInfo
    let errCnt = 0
    let isFocus = false

    Object.keys(node).forEach((key, index) => {
      let message = null

      //필수 체크
      if (node[key].required) {
        if (key === 'fileCd') {
          if (!itemInput?.[key] || itemInput?.[key]?.length <= 0) {
            errCnt++
            return props.error({ message: '근거서류명을 선택해주세요.' })
          }
        } else {
          if (!itemInput?.[key] || itemInput?.[key]?.length <= 0) {
            message = node[key]?.message
            errCnt++
          }
        }
      }

      node[key].errMessage = message

      if (!isFocus && errCnt === 1) {
        isFocus = true
        if (node.itemnm.itemnm) {
          inputRef.current[index].focus()
        }
      }
    })

    if (!itemInput.stngYmd || itemInput.stngYmd?.length <= 0) {
      setState({ ...state, errStngYmd: '선적기일을 선택해주세요.' })
      errCnt++
    }

    if (errCnt > 0) return
    ;(!itemInput.fileCd || itemInput.fileCd?.length <= 0) && (itemInput.fileCd = '811')
    itemInput.issueType = 'KTNET'
    itemInput.issueCd = 'KTNET'

    props.saveStep(props.docid, '3', itemInput, isEdit)
  }

  /**
   * 물품정보 수정
   * @param seq
   */
  const selectEdit = (crtFileSeq, index = -1) => {
    if (editIdx === index) {
      newInput()
    } else {
      setItemInput({ ...itemList[itemList.findIndex((item) => item.crtFileSeq === crtFileSeq)] })
      setIsEdit(true)
      setEditIdx(index)
    }
  }

  /**
   * 새로작성
   */
  const newInput = () => {
    setState({ ...state, errStngYmd: '', fileCd: '' })
    let node = nodeInfo
    Object.keys(node).forEach((key, index) => {
      node[key].errMessage = null
    })

    setSelectItems([])
    setItemInput({})
    setIsEdit(false)
    setEditIdx(-1)
    setReset(true)
  }

  /**
   * 선택삭제
   * @returns {*}
   */
  const deleteItems = () => {
    if (selectItems?.length <= 0) {
      return props.error({ message: '삭제할 물품을 선택해주세요.' })
    }

    props.confirm({
      title: '확인',
      message: '정말 삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          props.deleteStepItems(props.docid, '3', selectItems)
        },
      },
    })
  }

  /**
   * 전체삭제
   */
  const deleteAll = () => {
    itemList?.length > 0 &&
      props.confirm({
        title: '확인',
        message: '정말 삭제하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.deleteStepItemAll(props.docid, '3')
          },
        },
      })
  }

  const handleClose = () => {
    props.onClose()
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setItemInput({
      ...itemInput,
      [name]: value,
    })
  }

  const onSelectItem = (e) => {
    const { name, checked } = e.target
    let list = selectItems
    if (checked) {
      list.push(name)
    } else {
      list = selectItems.filter((item) => item !== name)
    }
    setSelectItems(list)
  }

  const generateInput = (key) => {
    const node = nodeInfo[key]
    let idx = Object.keys(nodeBaseInfo).findIndex((objKey) => objKey === key)
    let className = ''
    let wrapperClassName = node?.wrapperClassName
    let maxLength = node.length
    !maxLength && node?.type === 'number' && (className += 'right ')
    !maxLength && node?.type === 'number' && (maxLength = 16)

    return (
      <Input
        id={key}
        name={key}
        type={node.type}
        value={itemInput?.[key] || ''}
        inputTitle={node?.inputTitle ? node?.inputTitle : node?.title}
        ref={(ref) => (inputRef.current[idx] = ref)}
        wrapperClassName={wrapperClassName}
        className={className + node?.className}
        placeholder={node?.placeholder}
        message={node?.message}
        onChange={handleChange}
        readOnly={node.readOnly}
        required={node.required}
        flow={node.flow ? node.flow : `${window.innerWidth >= 767 ? 'left' : 'up'}`}
        length={maxLength}
        errMessage={node.errMessage}
      />
    )
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '1',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '2',
    display: 'block',
  }

  return (
    <React.Fragment>
      {/* 근거서류 등록 / 수정 */}
      <div style={style}></div>
      <div style={styleModal} id="document-register" className="modal w1120">
        <div className="modal-head">
          <h2>근거서류 등록</h2>
        </div>
        <div className="modal-cont">
          <table className="tbl-write">
            <caption>근거서류명, 품명/규격, HS부호, 산적기일 항목으로 구성</caption>
            <colgroup>
              <col className="col1" />
              <col className="col2" />
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required" /> 근거서류명
                </th>
                <td>
                  <select title="근거서류명" id="fileCd" name="fileCd" onChange={handleChange} value={itemInput?.['fileCd'] || ''}>
                    <option value="">선택</option>
                    {fileType.map((type, index) => {
                      return (
                        <option key={'cd' + index} value={type.value}>
                          {type.title}
                        </option>
                      )
                    })}
                  </select>
                </td>
                <th scope="row">
                  <em className="required" /> 근거서류번호
                </th>
                <td>{generateInput('fileNo')}</td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 품명/규격
                </th>
                <td colSpan={3}>
                  <span className="input-group full">
                    {generateInput('itemnm')}
                    {/* <input
                      type="text"
                      id="itemnm"
                      title="품명"
                      name="itemnm"
                      className="form-keyword col2"
                      placeholder="'구매 물품 목록'에서 입력한 제품을 선택합니다."
                      readOnly
                      value={itemInput?.['itemnm'] || ''}
                    /> */}
                    {common.getDeviceType() !== 'MobileApp' ? (
                      <a
                        href="#"
                        className="btn-secondary sm"
                        onClick={(e) => {
                          e.preventDefault()
                          props.isShowItems(true)
                        }}
                      >
                        구매물품선택
                      </a>
                    ) : (
                      <a
                        href="#"
                        className="btn-secondary sm"
                        onClick={(e) => {
                          e.preventDefault()
                          props.isShowItems(true)
                        }}
                      >
                        선택
                      </a>
                    )}

                    {/* {generateInput('itemdeftxt')} */}
                    <input
                      type="text"
                      id="itemdeftxt"
                      title="규격"
                      name="itemdeftxt"
                      className="form-keyword col2"
                      placeholder="'구매 물품 목록'에서 입력한 제품을 선택합니다."
                      readOnly
                      value={itemInput?.['itemdeftxt'] || ''}
                    />
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> HS부호
                </th>
                <td>
                  {generateInput('hsCd')}
                  <p className="desc">근거서류당 1개의 대표 HS부호만 등록하시면 됩니다.</p>
                </td>
                <th scope="row">
                  <em className="required" /> 총 금액
                </th>
                <td>
                  <span className="input-group full">
                    <select
                      id="totamtcur"
                      title={'통화코드'}
                      name="totamtcur"
                      value={itemInput.totamtcur || 'KRW'}
                      onChange={handleChange}
                      className="form-category w120"
                    >
                      <option value="">통화코드</option>
                      <option value="USD">USD</option>
                      <option value="KRW">KRW</option>
                    </select>
                    {generateInput('amt')}
                  </span>
                </td>
              </tr>
              <tr colSpan={3}>
                <th scope="row">
                  <em className="required" /> 산적기일
                </th>
                <td>
                  {reset === false && (
                    <span className="datepicker">
                      <Calendar
                        default={itemInput.stngYmd && moment(itemInput.stngYmd, 'YYYYMMDD').format('YYYY-MM-DD')}
                        onSelect={(value) =>
                          setItemInput({
                            ...itemInput,
                            stngYmd: moment(value).format('YYYYMMDD'),
                          })
                        }
                      />
                    </span>
                  )}
                  {state.errStngYmd && <span className="txt">{state.errStngYmd}</span>}
                </td>
              </tr>
            </tbody>
          </table>
          <div className="btn-block center">
            <a
              href="#"
              className="btn-secondary md"
              onClick={(e) => {
                e.preventDefault()
                newInput()
              }}
            >
              새로작성
            </a>
            <a
              href="#"
              className="btn-primary md"
              onClick={(e) => {
                e.preventDefault()
                saveItem()
              }}
            >
              {isEdit === true ? '수정' : '저장'}
            </a>
          </div>

          <div className="list-header">
            <span className="total-num">총 {itemList?.length}건</span>
            <span className="right">
              <a
                href="#"
                className="btn-secondary sm"
                onClick={(e) => {
                  e.preventDefault()
                  deleteItems()
                }}
              >
                선택삭제
              </a>
              <a
                href="#"
                className="btn-secondary sm"
                onClick={(e) => {
                  e.preventDefault()
                  deleteAll()
                }}
              >
                전체삭제
              </a>
            </span>
          </div>
          <div className="tbl-wrap">
            <table className="tbl-list">
              <caption>선택, 근거서류명 및 번호, HS부호, 품명, 규격, 금액, 산적기일 항목으로 구성</caption>
              <colgroup>
                <col style={{ width: '7%' }} />
                <col style={{ width: '17%' }} />
                <col style={{ width: '12%' }} />
                <col style={{ width: '24%' }} />
                <col style={{ width: '13%' }} />
                <col style={{ width: '13%' }} />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">선택</th>
                  <th scope="col">근거서류명 및 번호</th>
                  <th scope="col">HS부호</th>
                  <th scope="col">품명</th>
                  <th scope="col">규격</th>
                  <th scope="col">금액</th>
                  <th scope="col">선적기일</th>
                </tr>
              </thead>
              <tbody>
                {itemList?.length > 0 ? (
                  itemList?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="cell">
                          <input type="checkbox" title={'checkbox' + index} name={item.crtFileSeq} onChange={onSelectItem} />
                          <em />
                        </td>
                        <td className="cell" data-title={'근거서류명 및 번호'} onClick={() => selectEdit(item.crtFileSeq, index)}>
                          {
                            fileType.find((file) => {
                              return file.value === item.fileCd
                            })?.title
                          }
                          <br />[{item.fileNo}]
                        </td>
                        <td className="cell" data-title={'HS부호'} onClick={() => selectEdit(item.crtFileSeq, index)}>
                          {item.hsCd}
                        </td>
                        <td className="cell" data-title={'품명'} onClick={() => selectEdit(item.crtFileSeq, index)}>
                          {item.itemnm}
                        </td>
                        <td className="cell" data-title={'규격'} onClick={() => selectEdit(item.crtFileSeq, index)}>
                          {item.itemdeftxt}
                        </td>
                        <td className="cell" data-title={'금액'}>
                          {item.totamtcur} {commons.addComma(item.amt)}
                        </td>
                        <td className="cell" data-title={'선적기일'}>
                          {moment(item.stngYmd).format('Y-M-D')}
                        </td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan={7}>
                      <div className="nodata">등록된 자료가 없습니다.</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <button type="button" className="modal-close b-close" onClick={handleClose}>
          창닫기
        </button>
      </div>
      {/* 근거서류 등록/수정 */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.certapply?.data?.step3,
    isCalled: state.certapply.isCalled,
    selectItemSeq: state.certapply.itemSeq,
  }
}

const actionCreators = {
  saveStep: certapplyActions.saveStep,
  setCalled: certapplyActions.setCalled,
  error: alertActions.error,
  confirm: alertActions.confirm,
  deleteStepItems: certapplyActions.deleteStepItems,
  deleteStepItemAll: certapplyActions.deleteStepItemAll,
  isShowItems: certapplyActions.isShowItems,
}

export default connect(mapStateToProps, actionCreators)(PopFiles)
